// ===================
// Listing of Portfolio Entries
// ===================
PortfolioApp.Collections.Entries = Backbone.Collection.extend({
	model: PortfolioApp.Models.Entry,
	url: '/wp-content/themes/kentheberling/build/scripts/portfolio.entries.json'
});
